import * as React from 'react';

export type UpdateProviderType<T> = (arg: Partial<T>) => void;
export type ContextValueType<T> = T & {
    updateProvider: UpdateProviderType<T>;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type AnyObject = { [key: string]: any };
export const Context = React.createContext({} as ContextValueType<AnyObject>);

type UpdateContextProviderMethod = <T>(value: T) => void;

export interface IProps<T> {
    children: React.ReactChild;
    updateContextProvider: UpdateProviderType<T>;
    contextHasValue: boolean;
}

abstract class UpdateContextProvider<V, T extends IProps<V>> extends React.Component<T> {
    protected hasValue: boolean = false;

    updateContextProvider: UpdateContextProviderMethod = value => {
        if (!this.props.updateContextProvider) {
            throw new Error('Need to place a valid context Provider on top of this consumer');
        }
        if (value) {
            this.props.updateContextProvider(value);
        }
    };

    render() {
        if (!this.props.contextHasValue) {
            return null;
        }

        return this.props.children;
    }
}

export { UpdateContextProvider };
